var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"left-right-container"},[_c('div',{ref:"left",staticClass:"left"},[_vm._t("left")],2),_c('div',{ref:"line",staticClass:"line"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rightShow),expression:"rightShow"}],ref:"right",staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }